import React, { useState } from 'react';
import Rating from '../../../utils/Rating';
import RatingExplainer from '../../../utils/RatingExplainer';
import DaySummaryAnalyzer from '../../../utils/DaySummaryAnalyzer';
import RatingExplainerPopup from '../../common/RatingExplainerPopup';
import ScoreCountHourly from '../../common/ScoreCountHourly';

const RatingRow = ({dayData, data, currentSpot}) => {
    const [activePopup, setActivePopup] = useState(null);
    const [currentExplainer, setCurrentExplainer] = useState(null);
    const [timeLabel, setTimeLabel] = useState(null);
    const [daySummary, setDaySummary] = useState(null);

    if(!currentSpot){
        return <></>
    }

    const {preferred_wave_height_min, preferred_wave_height_max, preferred_swell_period_min, preferred_swell_period_max, preferred_wind_speed_min, preferred_wind_speed_max, preferred_wind_direction, preferred_swell_direction} = currentSpot;    

    if(!preferred_wave_height_min && !preferred_wave_height_max && !preferred_swell_period_min && !preferred_swell_period_max && !preferred_wind_speed_min && !preferred_wind_speed_max && !preferred_wind_direction && !preferred_swell_direction){
        return <></>
    }

    return (
        <>
            <tr className="hover:bg-custom-darker/50 transition-colors">
                <td className="pl-2 pb-1 pt-2 text-xs text-custom-light-grey ">
                    <div className="inline-flex items-center gap-1 font-medium flex-wrap">
                        <div>
                            <span className="block sm:hidden">Rating</span>
                            <span className="hidden sm:inline-block">Star Rating</span>
                        </div>
                        <button
                            onClick={() => {
                                // Create day summary analysis
                                const analyzer = new DaySummaryAnalyzer(
                                    dayData,
                                    data,
                                    {
                                        preferred_wave_height_min,
                                        preferred_wave_height_max,
                                        preferred_swell_period_min,
                                        preferred_swell_period_max,
                                        preferred_wind_speed_min,
                                        preferred_wind_speed_max,
                                        preferred_wind_direction,
                                        preferred_swell_direction
                                    }
                                );
                                setDaySummary(analyzer.getDaySummary());
                                setCurrentExplainer(null);
                                setTimeLabel(null);
                                setActivePopup('summary');
                            }}
                            className="text-custom-light-blue hover:text-custom-light-blue/80 transition-colors"
                            title="View day summary and forecast analysis"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                            </svg>
                        </button>
                    </div>
                </td>
                {dayData.map(({ index }) => {

                    const rating = new Rating({
                        waveheight: data.wave_height?.[index],
                        swellperiod: data.swell_wave_period?.[index],
                        swelldirection: data.swell_wave_direction?.[index],
                        windspeed: data.wind_speed_10m?.[index],
                        winddirection: data.wind_direction_10m?.[index]
                    }, {
                        preferred_wave_height_min,
                        preferred_wave_height_max,
                        preferred_swell_period_min,
                        preferred_swell_period_max,
                        preferred_wind_speed_min,
                        preferred_wind_speed_max,
                        preferred_wind_direction,
                        preferred_swell_direction
                    })

                    return (
                        <td key={index} className="pl-2 pb-1 pt-2 text-center relative">
                            <div 
                                className="inline-flex flex-col items-center gap-1 cursor-pointer relative"
                                onClick={() => {
                                    const explainer = new RatingExplainer(rating);
                                    const currentTime = dayData.find(d => d.index === index)?.dateTime;
                                    setCurrentExplainer(explainer);
                                    setTimeLabel(currentTime ? `${currentTime.date} at ${currentTime.hour}` : null);
                                    setActivePopup(index);
                                }}
                            >
                                <ScoreCountHourly score={rating.score} />
                            </div>
                        </td>
                    );
                })}
            </tr>
            
            {/* Rating Explainer Popup */}
            <RatingExplainerPopup 
                isOpen={activePopup !== null}
                onClose={() => {
                    setActivePopup(null);
                    setCurrentExplainer(null);
                    setTimeLabel(null);
                    setDaySummary(null);
                }}
                explainer={currentExplainer}
                timeLabel={timeLabel}
                daySummary={daySummary}
            />
        </>
    )
}

export default RatingRow;